var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dots",style:(_vm.dotsStyle)},_vm._l((_vm.totalDots),function(dot,index){return _c('span',{key:index,staticClass:"material-icons",style:(_vm.iconStyle)},[_vm._v(" fiber_manual_record ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }